module.exports = __webpack_public_path__ + "img/logo-dinapsis-aplicaciones.734b6493.svg";